import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { ArtifactSchema, SearchOptionProps } from "@/types";
import { searchStore } from "@/hooks";
import { ListItem } from "@/components/common";
import { ArtifactBodyDisplay } from "@/components/artifact/display";


/**
 * Displays a selectable artifact or artifact type option in the searchbar.
 */
const __default__ = {
  name: "SearchOption",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    option: {}
  },
  setup(__props: any) {

const props = __props;

const artifactLikeMode = computed(() => searchStore.artifactLikeMode);

return (_ctx: any,_cache: any) => {
  return (artifactLikeMode.value)
    ? (_openBlock(), _createBlock(_unref(ArtifactBodyDisplay), {
        key: 0,
        clickable: "",
        "display-title": "",
        artifact: props.option as ArtifactSchema,
        "data-cy": "text-artifact-search-item"
      }, null, 8, ["artifact"]))
    : (_openBlock(), _createBlock(_unref(ListItem), {
        key: 1,
        clickable: "",
        title: props.option as string
      }, null, 8, ["title"]))
}
}

})